export default "__VITE_ASSET__WXP1Qxob__"